import { Alert, Box, Stack, Typography } from '@mui/material'

/**
 * Pr PSS Label tab placeholder.
 *
 * Access evidence (DocConvert_Quality_overview §6.4):
 *  - Parent subform: `form_frmQualityPssLableSubForm.txt`
 *  - RecordSource: `tlc_factory_view_factory_sampling_psslable2 WHERE is_status=0 AND sample_no = '<cblotclient>'`
 *  - Controls: `cblotclient` (sample_no chooser), `cbCopies` (value list 1-4), `btnPrintRp` (Print preview)
 *
 * Single-record label printer. Report file chưa thấy trong `access_all`; cần confirm trước khi build print.
 */
export default function PssLabelView() {
  return (
    <Box sx={{ py: 2 }}>
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" fontWeight={700}>
          Pr PSS Label
        </Typography>
        <Alert severity="info" variant="outlined">
          Tab này chưa được build chi tiết. Theo Access (`frmQualityPssLableSubForm`) đây là
          single-record label printer: sample_no chooser + Copies select (1-4) + Print preview.
        </Alert>
        <Typography variant="body2" color="text.secondary">
          Tham khảo <code>DocConvert_Quality_overview.md §6.4</code> trước khi implement;
          xác nhận report file `rpQualityPssLable*` (chưa có evidence trong <code>access_all</code>).
        </Typography>
      </Stack>
    </Box>
  )
}
